// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__2SD3Y","header":"ReportDetails_header__25UBU","title":"ReportDetails_title__1Cm_H","left":"ReportDetails_left__rhhOl"};